import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'


export type IRmaOrderDTO = {
  invoice_number: string
  shipment_date: string | null
  saleID: string
  sale_reference: string
  shipmentID: string | null
  shipment_reference: string | null
  customer_order_nr: string | null
  counted_results: number
  sale_date: string | null
  erp_order_number: string | null
}


export class RmaOrderDTO {
  invoiceNumber: string
  shipmentDate: string | null
  saleId: string
  saleReference: string
  shipmentId: string | null
  shipmentReference: string | null
  customerOrderNr: string | null
  countedResults: number
  saleDate: string | null
  erpOrderNumber: string | null

  constructor(data: IRmaOrderDTO) {
    this.invoiceNumber = data.invoice_number
    this.shipmentDate = data.shipment_date
    this.saleId = data.saleID
    this.saleReference = data.sale_reference
    this.shipmentId = data.shipmentID
    this.shipmentReference = data.shipment_reference
    this.customerOrderNr = data.customer_order_nr
    this.countedResults = data.counted_results
    this.saleDate = data.sale_date
    this.erpOrderNumber = data.erp_order_number
  }
}


const validate = createValidate<IRmaOrderDTO>()

const parseRmaOrderDTO = (data: unknown): RmaOrderDTO => {
  validateGuard(validate, data, 'rma order')
  return new RmaOrderDTO(data)
}


const validateList = createValidate<IRmaOrderDTO[]>()

export const parseRmaOrderDTOList = (data: unknown): RmaOrderDTO[] => {
  validateGuard(validateList, data, 'rma orders')
  return (data as IRmaOrderDTO[]).map(parseRmaOrderDTO)
}
